<template>
  <div>
    <h2>每日班表</h2>
    <br />
    <label style="color: red">點圖可放大，表格可往右滑</label>
  </div>

  <div class="container" id="con1">
    <ul class="nav nav-tabs" id="nav">
      <li v-for="tab in tabs" :key="tab.id || tab.name" class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: tab.isActive }"
          @click.prevent="setActive(tab)"
          >{{ tab.name }}</a
        >
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-expanded="false"
          id="DropdownMenu"
          >更多</a
        >
        <ul class="dropdown-menu"></ul>
      </li>
    </ul>

    <div class="tab-content">
      <Spa_Daily_El
        :date="refreshdate"
        :spa="spa_id"
        :conWidth="conWidth"
        :rule2="rule2"
      ></Spa_Daily_El>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Spa_Daily_El from "@/components/Spa_Daily_El.vue";

export default {
  data() {
    return {
      tabs: [],
      activeTab: {},
      conWidth: "",
      spa_id: "",
      refreshdate: "",
      rule2: "",
      lineLink3: "",
    };
  },
  components: {
    Spa_Daily_El,
  },
  methods: {
    async selectAll() {
      try {
        // 優化 1：使用 Promise.all 並行請求，縮短載入時間
        const [configRes, linkRes] = await Promise.all([
          axios.post("/php/spa_config.php", { action: "selectAll" }),
          axios.post("/php/spa_config.php", { action: "selectLink" }),
        ]);

        // 處理 config 資料
        if (Array.isArray(configRes.data)) {
          this.tabs = configRes.data;
          const findTab = this.tabs.find((e) => e.seq == "1") || this.tabs[0];

          if (findTab) {
            findTab.isActive = true;
            this.spa_id = findTab.id;
            this.refreshdate = findTab.refreshdate;
            this.rule2 = findTab.rule2; // 避免直接拼裝 HTML，保持資料乾淨
          }
        }

        // 處理 link 資料
        if (Array.isArray(linkRes.data)) {
          const findLine3 = linkRes.data.find((e) => e.code === "lineLink3");
          if (findLine3) {
            this.lineLink3 = findLine3.text;
          }
        }
      } catch (error) {
        console.error("載入選單配置失敗:", error);
      } finally {
        this.$nextTick(() => {
          this.setDropdown("#nav", 50);
        });
      }
    },
    setActive(tab) {
      this.activeTab = tab;
      this.spa_id = tab.id;
      this.refreshdate = tab.refreshdate;
      this.rule2 = tab.rule2;

      this.tabs.forEach((item) => {
        item.isActive = item === tab;
      });
    },
    setDropdown(menu, maxHeight) {
      var nav = $(menu);
      if (!nav.length) return;

      var navHeight = nav.innerHeight();
      if (navHeight >= maxHeight) {
        $(menu + " .dropdown").removeClass("d-none");
        $(".navbar-nav").removeClass("w-auto").addClass("w-100");

        while (navHeight > maxHeight) {
          var children = nav.children(menu + " li:not(:last-child)");
          var count = children.length;
          if (count === 0) break;
          $(children[count - 1]).prependTo(menu + " .dropdown-menu");
          navHeight = nav.innerHeight();
        }
        $(".navbar-nav").addClass("w-auto").removeClass("w-100");
      } else {
        var collapsed = $(menu + " .dropdown-menu").children(menu + " li");

        if (collapsed.length === 0) {
          $(menu + " .dropdown").addClass("d-none");
        }

        while (
          navHeight < maxHeight &&
          nav.children(menu + " li").length > 0 &&
          collapsed.length > 0
        ) {
          collapsed = $(menu + " .dropdown-menu").children("li");
          $(collapsed[0]).insertBefore(nav.children(menu + " li:last-child"));
          navHeight = nav.innerHeight();
        }

        if (navHeight > maxHeight) {
          this.setDropdown(menu, maxHeight);
        }
      }
    },
    resizeHandler() {
      this.setDropdown("#nav", 50);
    },
  },
  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  mounted() {
    this.selectAll();
    this.conWidth = $("#con1").width();
  },
};
</script>

<style scoped>
.nav-tabsa {
  position: fixed;
  z-index: 100;
}
</style>
